import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';
import asterisk from '../asserts/as.png';
import './Splashscreen.css';

const SplashScreen = () => {
    const navigate = useNavigate();

    const outerSquareRef = useRef(null);
    const innerSquareRef = useRef(null);
    const logoRef = useRef(null);
    const titleLineOneRef = useRef(null);
    const titleLineTwoRef = useRef(null);
    const labelRef = useRef(null);
    const asteriskRef = useRef(null);
    const screenRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set(outerSquareRef.current, { opacity: 0, scale: 0.5, rotation: 30 });
        gsap.set(innerSquareRef.current, { opacity: 0, scale: 0.3, rotation: -40 });
        gsap.set(logoRef.current, { opacity: 0, scale: 0.4 });
        gsap.set(titleLineOneRef.current, { opacity: 0, y: 50, skewX: -8 });
        gsap.set(titleLineTwoRef.current, { opacity: 0, y: 50, skewX: -8 });
        gsap.set(labelRef.current, { opacity: 0, scaleX: 0, transformOrigin: 'center center' });
        gsap.set(asteriskRef.current, { opacity: 0, y: 260, rotation: -90, scale: 1.3 });

        tl.to(outerSquareRef.current, { opacity: 1, scale: 1, rotation: 0, duration: 0.75, ease: 'back.out(1.7)' })
          .to(innerSquareRef.current, { opacity: 1, scale: 1, rotation: 0, duration: 0.65, ease: 'back.out(1.5)' }, '-=0.45')
          .to(logoRef.current, { opacity: 1, scale: 1, duration: 0.5 }, '-=0.3')
          .to(titleLineOneRef.current, { opacity: 1, y: 0, skewX: 0, duration: 0.7, ease: 'power4.out' }, '-=0.2')
          .to(titleLineTwoRef.current, { opacity: 1, y: 0, skewX: 0, duration: 0.7, ease: 'power4.out' }, '-=0.5')
          .to(labelRef.current, { opacity: 1, scaleX: 1, duration: 0.55, ease: 'expo.out' }, '-=0.3')
          .to(asteriskRef.current, { opacity: 1, y: 0, rotation: 0, scale: 1, duration: 1.1, ease: 'power4.out' }, '-=0.1')
          .to(asteriskRef.current, { rotation: 18, duration: 1.4, ease: 'sine.inOut', yoyo: true, repeat: 1 }, '+=0.3')
          .to(screenRef.current, { opacity: 0, duration: 0.6, ease: 'power2.inOut' }, '+=0.2')
          .call(() => navigate('/login'));
    }, [navigate]);

    return (
        <div className="home-wrapper">
            <div className="mobile-container">
                <main 
                    className="splash-screen" 
                    ref={screenRef} 
                    role="status" 
                    aria-live="polite" 
                    aria-busy="true"
                    aria-label="Loading The Design Show Cairo 2026"
                >
                    <span className="sr-only">The Design Show Cairo 2026 is loading...</span>

                    <div className="splash-bg-pattern" aria-hidden="true"></div>

                    <div className="splash-body">
                        <div className="splash-logo-wrap" aria-hidden="true">
                            <div className="splash-outer-sq" ref={outerSquareRef}></div>
                            <div className="splash-inner-sq" ref={innerSquareRef}></div>
                        </div>

                        <div className="splash-text">
                            <h1 className="splash-title">
                                <span className="splash-title-line" ref={titleLineOneRef}>THE DESIGN</span>
                                <span className="splash-title-line" ref={titleLineTwoRef}>SHOW</span>
                            </h1>
                            <div className="splash-label-wrap" ref={labelRef}>
                                <span className="splash-label">CAIRO 2026</span>
                            </div>
                        </div>
                    </div>

                    <div className="splash-asterisk-wrap" ref={asteriskRef} aria-hidden="true">
                        <img src={asterisk} alt="" className="splash-asterisk" />
                    </div>

                </main>
            </div>
        </div>
    );
};

export default SplashScreen;